/**
 * Responsive flags and viewport sizing constants for the regional map.
 * Author: bb
 */

const MOBILE_BREAKPOINT = 640;
const TABLET_BREAKPOINT = 1024;
const DEFAULT_VIEWPORT_WIDTH = TABLET_BREAKPOINT;

const resolveViewportWidth = (value?: number | null): number => {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }
  if (typeof window !== "undefined" && Number.isFinite(window.innerWidth)) {
    return window.innerWidth;
  }
  return DEFAULT_VIEWPORT_WIDTH;
};

export const resolveMapResponsive = (viewportWidth?: number | null) => {
  const width = resolveViewportWidth(viewportWidth);
  const isMobile = width < MOBILE_BREAKPOINT;
  const isTablet = width < TABLET_BREAKPOINT;
  return {
    isMobile,
    isTablet,
    centerLat: isMobile ? 51.3 : isTablet ? 51.1 : 50.9,
    scale: isMobile ? 3000 : isTablet ? 3500 : 3800,
  };
};
